import Http from "./Http";

export const loginCustomer = (data) => Http.post(`/customers/login`, data);
export const logoutCustomer = (id) => Http.get(`/customers/${id}/logout`);